import React, { useEffect, useState } from 'react'
import { calculateTimeLeft } from '../../utils/utils';


interface TypeCountDown {
  expiryTime: any,
  prefix?: string
}

const CountDown: React.FC<TypeCountDown> = ({ expiryTime, prefix = 'starts in' }) => {
  const [timeLeft, setTimeLeft] = useState({ minutes: 0, seconds: 0 });

  useEffect(() => {
    const interval = setInterval(() => {
      const time = calculateTimeLeft(expiryTime);
      setTimeLeft(time);
    });
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="contest-count-down">
      {prefix} {`${timeLeft.minutes}:`.padStart(3, '0')}{`${timeLeft.seconds}`.padStart(2, '0')}
    </div>
  )
}

export default CountDown;
